module.exports = __webpack_public_path__ + "img/header-page-fmf-2.ba9e6eba.png";